import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=6260f7e2&scoped=true&"
var script = {}
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=6260f7e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6260f7e2",
  null
  
)

export default component.exports